<template>
<div id="vy_body">
  <div id="vy_grid">
    <div id="vy_left_nav" class="p-4">
      <!--左サイドバー-->
          <component v-bind:is="contentLeft"
                     v-bind:key="left_bar_render"
                     v-bind:param="param_left"
                     v-on:call="call"/>
    </div>

    <div id="vy_main">
      <main>
        <component v-if="displayStatus"
                   v-bind:is="content"
                   v-bind:param="param"
                   v-on:call="call"
                   v-bind:key="render"
                   ref="comp">{{ title }}</component>

        <!--ボタンエリア-->
        <div class="vy-responsive-menu-container">
            <div class="vy-responsive-menu-button_left" v-on:click="Smart_home()">
                <img id="vy-logo" v-if="(route.params.cmd == '' || route.params.cmd == 'home' || route.params.cmd == null) && Smart_search_open==0" src="../../images/smart/icon_home_red.png" alt="HOME" />
                <img id="vy-logo" v-else src="../../images/smart/icon_home.png" alt="HOME" />
            </div>

            <div class="vy-responsive-menu-button_center"></div>

            <div class="vy-responsive-menu-button_right" v-on:click="Smart_search()">
              <img id="vy-logo" v-if="Smart_search_open==1" src="../../images/smart/icon_search_red.png" alt="検索" />
              <img id="vy-logo" v-else src="../../images/smart/icon_search.png" alt="検索" />
            </div>

<!--            
            <div class="vy-responsive-menu-button_right" v-on:click="Smart_login()">
                <img id="vy-logo" v-if="GlobalData.$User_email" src="../../images/smart/icon_login.png" alt="ログアウト" />
                <img id="vy-logo" v-else src="../../images/smart/icon_login.png" alt="ログイン" />
            </div>
-->
        </div>
        <!--フッター-->
        <FooterArea v-on:call="call"/>
      </main>
    </div>

    <div id="vy_right_nav" class="p-4">
        <!--右サイドバー-->
        <ShisetsuRightBar v-on:call="call"/>
    </div>

  </div>
</div>
        
<!--メッセージを表示するモーダルウィンドウ-->
<component v-bind:is="contentMessage"
            v-bind:message_text="message"
            v-bind:message_cat="message_cat"
            v-bind:message_flag="message_flag"
            v-on:call="call"
            v-on:close_message="Close_message"
            v-on:ok_message="OK_message"/>

<!-- ローディングアイコンを表示するモーダルウィンドウ -->
<LoadingModal v-if="loading_flg"/>

</template>

<script setup>
/* eslint-disable */
import ShisetsuHome from './ShisetsuHome.vue'
import ShisetsuLeftbar from './ShisetsuLeftBar.vue'
import ShisetsuRightBar from './ShisetsuRightBar.vue'
import ShisetsuMyCode from './ShisetsuMyCode.vue'
import ShisetsuTaikenDetail from './ShisetsuTaikenDetail.vue'
import ShisetsuTaikenDetailLeftbar from './ShisetsuTaikenDetailLeftBar.vue'
import ShisetsuTaikenRirekiLeftbar from './ShisetsuTaikenRirekiLeftbar.vue'
import ShisetsuTaikenRireki from './ShisetsuTaikenRireki.vue'
import Leftbar from './LeftBar.vue'
import UserCheckin from './UserCheckin.vue'
import UserSearchSmart from './UserSearchSmart.vue'
import FooterArea from '../common/FooterArea.vue'
import { GlobalData, login_check, Kaisai_setting, logout } from '../js/userdata_shisetsu.js';
import { useRouter, useRoute } from 'vue-router'
import { watch, ref, nextTick } from 'vue'
import axios from 'axios'
import { CognitoUserPool } from 'amazon-cognito-identity-js'

/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

const router = useRouter();
const route = useRoute();
GlobalData.shakyo = route.params.shakyo
GlobalData.facility_code = route.params.shisetsu

const displayStatus = ref(true) //子コンポーネントを再レンダリングさせるためのフラグ

// 左メニューの再描画(申込者情報画面の左メニュー)
let left_bar_render = ref(0)

login_check()

const emit = defineEmits(['call'])

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ
const contentLeft = ref('')// 表示する子コンポーネントの情報（左バー）

// メッセージ・キャンセル履歴画面に関するデータベース項目
let rireki_kubun = 1 //1:申込者一覧、2：申込キャンセル、8：メッセージ履歴
let rireki_start_date = "" // 履歴期間（自）
let rireki_end_date = "" // 履歴期間（至）
let rireki_program_id = 0 // 絞り込むプログラムID
let rireki_order = "toroku_timestamp"
let rireki_mode = "ASC"
let rireki_username = "" // 絞り込むユーザー名

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

const url = GlobalData.$API_URL

import { useStore } from 'vuex'
const store = useStore()

const render = ref(0);
let loading_flg = ref(false)

// メール未読が何件あるか
// let midoku_count = ref(0)

const contentUserSwitch = ref("")// 表示する子コンポーネントの情報（複数ユーザー対応 ユーザー切替え画面）
contentUserSwitch.value = null// 表示する子コンポーネント

let Smart_search_open = ref(null)

//const content = shallowRef('')
const content = ref(null)

let cityname = route.params.shakyo
let facility = route.params.shisetsu

let param = {}
let param_left = {}
let all_bunrui_list = []
let taiken = []
let Shakyo_data = {}

let title = "受入先"

// ロゴ、タイトルの対応
let header_title1 = "";
let header_title2 = "";

let header_logo = "";
  
let title_style1_pc = ref({"color":"black","font-size": "14px","margin":"15px 0 5px"})
let title_style2_pc = ref({"color":"black","font-size": "15px"})

let title_style1_sp = ref({"color":"black","font-size": "0.65em"})
let title_style2_sp = ref({"color":"black","font-size": "0.95em"})

let gakusei_kbn_list = [] // 学生区分の利用可不可
let gakusei_meisho_list = [] // 学生区分の名称

let choson_code = route.params.shakyo
let search_param = {}

let facility_id = 0

let list_scrollpos = 0

let f = {}
let facility_read_error = 0
//---------------- URLの受入先コードから受入先IDを取得する
const facility_read = () => {

    // 施設コードより施設情報を読み込む
    axios.post(url + "Facility_read",
	{
        facility_code: GlobalData.facility_code,    
	},
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
	.then(response => {
        
        let res = response["data"]
        f = res["facility_info"]
        facility_id = f.facility_id
        
      })
    .catch(error => {
          if(facility_read_error == 6){
              message.value = error + GlobalData.$axios_error
              message_cat.value = 1;
              message_flag.value = true;
              message_method.value = "facility_read_error";
              contentMessage.value = MessageModal
          }else{
              facility_read_error++
              setTimeout(function(){facility_read()},"1000")
          } 
    })
}

facility_read()

//---------------- URLの社協から社協の情報を取得する
let shakyo_read = function(){
    axios.post(url+"Shakyo_read", 
        {shakyo:route.params.shakyo}
    ).then(response => {
        Shakyo_data =  response["data"]
        choson_code = response["data"].choson_code

        // ヘッダー関係の取得
        header_logo = response["data"].header_logo
        header_title1 =  response["data"].header_title1
        header_title2 =  response["data"].header_title2
        title_style1_pc.value["color"] = response["data"].header_title_color1
        title_style2_pc.value["color"] = response["data"].header_title_color2
        title_style1_sp.value["color"] = response["data"].header_title_color1
        title_style2_sp.value["color"] = response["data"].header_title_color2
        
        // 学生区分の取得
        gakusei_kbn_list = response["data"].gakusei_kbn_list.split(",")
        gakusei_meisho_list = response["data"].gakusei_meisho_list.split(",")
    })
    .catch(error => {
        if(facility_read_error == 6){
            message.value = error + GlobalData.$axios_error
            message_cat.value = 1;
            message_flag.value = true;
            message_method.value = "shakyo_read_error";
            contentMessage.value = MessageModal
        }else{
            facility_read_error++
            setTimeout(function(){facility_read()},"1000")
        } 
    })
}

shakyo_read()

let dsp_count = 0
let taiken_dsp_error = 0
//---------------- 体験プログラム一覧表示
const taiken_dsp = () => {

    if(choson_code != "" && facility_id != 0){
        search_param.choson_code = choson_code
        search_param.facility_id = facility_id
    }else if(dsp_count < 10){
        dsp_count++
        setTimeout(function(){taiken_dsp()},"1000")
        return
    }

    // 開催日が指定されていた場合、それが祝日かどうか
    let syuku_flg = 0
    if(search_param.kaisai_date != ""){
        for(let i  = 0 ;i<holiday_list.length;i++){
            if(holiday_list[i] == search_param.kaisai_date){
                syuku_flg = 1
            }
        }
    }

    search_param.syuku_flg = syuku_flg

    axios.post(url+"Taiken_get", search_param)
    .then(response => {
        taiken = response.data.taiken
            
        loading_flg.value = false
        render.value = render.value + 1
        title = "体験プログラム一覧"
        param = { 'program':taiken,'nittei':response.data.nittei,'sub':response.data.sub,'sub_nittei':response.data.sub_nittei,'cityname':cityname }
        content.value = ShisetsuHome

        param_left = {all_bunrui_list:all_bunrui_list,
            search_param:search_param,
            header_logo:header_logo,
            header_title1:header_title1,
            header_title2:header_title2,
            title_style1:title_style1_pc.value,
            title_style2:title_style2_pc.value,
            gakusei_kbn_list:gakusei_kbn_list,
            gakusei_meisho_list:gakusei_meisho_list}

        contentLeft.value = ShisetsuLeftbar
        // setTimeout(function(){Rightbar_setting()},"1000")
     
    })
    .catch(error => {
        if(taiken_dsp_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "Taiken_get_error";
            contentMessage.value = MessageModal
        }else{
            taiken_dsp_error++
            setTimeout(function(){taiken_dsp()},"1000")
        }
        
     //   alert("体験プログラム一覧の取得時にエラーが発生しました。"+error)
    })
}

const taiken_dsp_check = () => {

    if(GlobalData.$profile != null){
        if(Object.keys(store.state.taiken).length){
            search_param = store.state.taiken
        }else{
            search_param = { bunrui1:'', bunrui2:'', keyword:'',
                            kaisai_date:'', joken:'' , shimekiri:0}
        }
        taiken_dsp()
    } else {
        router.push("/"+route.params.shakyo+"/"+route.params.shisetsu+"/Shisetsu/MailLogin")
    }
}

// １件だけ読み出す
let read_error = 0
let Read = function(taiken_id) {
    axios.post(url + "Taiken_read",
    {
        taiken_id: taiken_id,
        choson_code:GlobalData.choson_code,//市区町村コード
    })//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        //正常な結果が返ってきた場合の処理
        // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
        // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する


        if(response.data["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
        }else{
            
            taiken = response["data"] // 配列を格納
            // 選択した体験プログラムの日程、開催日（自・至）を保存する
            //jyokyo_nittei.value = taiken.nittei
            //jyokyo_kaisai_start.value = taiken.kaisai_start
            //jyokyo_kaisai_end.value = taiken.kaisai_end
                
            // 詳細の表示（共通処理）へ
            Change_detail(taiken,taiken.nittei,taiken.sub_list,taiken.sub_nittei,taiken_id)
        }
    })
    .catch(error => {  
        if(read_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_method.value = "get_error";
            message_cat.value = 0;
            message_flag.value = true;
            contentMessage.value = MessageModal
        }else{
            read_error++
            setTimeout(function(){Read(taiken_id) },"1000")
        }
    })
}

// 詳細コンポーネントへの切替
let detail_jyokyo_error = 0
let Change_detail = function(taiken0,nittei0,sub0,sub_nittei0,taiken_id0){

    // 切り替える前に実績取得
        axios.post(url + "Taiken_Jissekiread",
    {
        taiken_id: taiken_id0,
    })//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        //正常な結果が返ってきた場合の処理
        // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
        // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

        // 処理が終わる前にコンポーネントが切り替えられていたら中断
        //if(route.params.cmd != 'detail') return
        //console.log(route.params.cmd)
        
        if(response.data["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
        }else{
                Page_scroll(0)
            // 送る値
            // taiken    ：体験プログラムの情報（配列）
            // nittei    ：体験プログラムの日程情報（配列×日程の数）  
            // sub       ：サブ体験プログラムの情報（配列×サブプログラムの数）
            // sub_nittei：体験プログラムの日程情報（配列×サブプログラムの数×日程の数） 
            // all_jizen ：体験プログラムに紐づかないものも含めた全事前説明会
            // all_jigo  ：体験プログラムに紐づかないものも含めた事後集会
            // type      ：このコンポーネントを利用するタイプ（0：新規登録、1：編集）
            // taiken_id ：表示中の体験プログラムのID
            // bunrui1   ：体験プログラム全体の「分類1」の配列（「Taiken_get」APIから取得したもの）
            // bunrui2   ：体験プログラム全体の「分類2」の配列（「Taiken_get」APIから取得したもの）
            // all_bunrui_list：体験プログラムに利用する分類1・2（「Category_read」APIから取得したもの）
            // jyokyo    ：サブも含めた全プログラムの実績（参加状況）
            // gakusei_kbn_list：参加条件（学生区分）の利用可不可
            // gakusei_meisho_list：参加条件（学生区分）の名称
            // shomei    ：証明書の索引リスト
            param = {"taiken":taiken0,
                    "nittei":nittei0,
                    "sub":sub0,
                    "sub_nittei":sub_nittei0,
                    'taiken_id':taiken_id0,
                    'all_jizen':[],
                    'all_jigo':[],
                    'type':1,
                    'bunrui1':[],
                    'bunrui2':[],
                    "all_bunrui_list":all_bunrui_list,
                    "jyokyo":response["data"].jisseki_all,
                    "gakusei_kbn_list":gakusei_kbn_list,
                    "gakusei_meisho_list":gakusei_meisho_list,
                    "shomei":[]}

                    console.log(response["data"])

            loading_flg.value = false        
            // 子コンポーネントを詳細に切替
            content.value = ShisetsuTaikenDetail
            
            Rendering_child()

            // 左メニュー表示
            if(Object.keys(store.state.taiken).length){
                search_param = store.state.taiken
            }else{
                search_param = { bunrui1:'', bunrui2:'', keyword:'',
                                kaisai_date:'', joken:'' , shimekiri:0}
            }
            param_left = {all_bunrui_list:all_bunrui_list,
                search_param:search_param,
                header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value,
                gakusei_kbn_list:gakusei_kbn_list,
                gakusei_meisho_list:gakusei_meisho_list}
            contentLeft.value = ShisetsuLeftbar

        }
    })
    .catch(error => {  
        if(detail_jyokyo_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_method.value = "get_error";
            message_cat.value = 0;
            message_flag.value = true;
            contentMessage.value = MessageModal
        }else{
            detail_jyokyo_error++
            setTimeout(function(){Change_detail(taiken0,nittei0,sub0,sub_nittei0,taiken_id0) },"1000")
        }
        
    })
   
}

// チェックイン前に事前説明会の実績を確認
let jizen_jisseki_check_error = 0
const Jizen_jisseki_check = (jizenkensyu_no,id,u_id) =>{
     // ユーザーID・区分・プログラムIDを指定する
     axios.post(url+"Taikenuser_Jisseki", {taikenuser_id:u_id, program_kbn:2}, GlobalData.$ID_Token)
    .then(response => {
        let jisseki_jizen = response.data.jisseki  // 自分の実績レコード（事前説明会）を取得する
        let jizen_ok = 0

        let no_array = jizenkensyu_no.split(",")
        // 0 件の場合は参加できず
        // 1件以上あっても、チェックインしてなければ参加できず
        if(jisseki_jizen.length != 0){
            // プログラムに格納された事前説明会のNo.を確認
            
            for(let n = 0;n<no_array.length;n++){
                // 事前説明会の実績を確認
                for(let j = 0 ;j<jisseki_jizen.length;j++){
                    
                    if(jisseki_jizen[j].syurui == 4 || jisseki_jizen[j].syurui == 5){
                        // 申込済みの事前説明会が「特殊（対面・オンライン）」の場合は問答無用で参加可能とする
                        if(jisseki_jizen[j].jokyo == '2'){
                          jizen_ok = 1
                        }
                    }else
                    // 事前説明会実績のNo.がプログラムに格納されたNo.と合致する場合
                    if(no_array[n] == jisseki_jizen[j].jizen_no){
                        // その実績が参加済であればOK
                        if(jisseki_jizen[j].jokyo == '2'){
                            jizen_ok = 1
                        }
                    }
                }
            }
        }
        if(jizen_ok == 0){
            loading_flg.value = false
            message.value = "事前説明会へ参加していないため、プログラムへのチェックインができません。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_kensyu";
            contentMessage.value = MessageModal
        }else{
            checkin(id,u_id,1);
        }
    })
    .catch(error => {
        if(jizen_jisseki_check_error == 6){
            loading_flg.value = false
            message.value = "チェックインを行うにはログインしてください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_login";
            contentMessage.value = MessageModal
        }else{
            jizen_jisseki_check_error++
            setTimeout(function(){Jizen_jisseki_check(jizenkensyu_no,id)},"1000")
            
        }
    })
}

//-------------------- チェックイン状態の確認
let checkin_error = 0
const checkin = (program_id,user_id,kbn,kensyu_date) => {

    let program_name = "事前説明会"
    if(kbn == 1){
        program_name = "体験プログラム"
    }else if(kbn == 3){
        program_name = "事後集会"
    }
    
    // ユーザーID・区分・プログラムIDを指定する
    axios.post(url+"Taikenuser_Jisseki", {taikenuser_id:user_id, program_kbn:kbn, program_id:program_id}, GlobalData.$ID_Token)
    .then(response => {
        loading_flg.value = false
        // ソーシャルログイン時に利用する戻る社協英名、画面、IDを削除
        localStorage.removeItem('return_shakyo')
        localStorage.removeItem('checkin')
        localStorage.removeItem('checkin_id')
        
        let jisseki_all = []
        jisseki_all[0] = response.data.jisseki
        // lambda側にjisseki_allは、無いのでロジックが変わった？
        // let jisseki_all = response.data.jisseki_all

        // 今日の日付（参加日と比較用）
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
        let today_set = set_date.getFullYear()+"-"+(set_date.getMonth()+1)+"-"+set_date.getDate()
        console.log("today:"+set_date)

        if(jisseki_all.length == 0){
            
            message.value = "この"+program_name+"には申込んでいません。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_moushikomi";
            contentMessage.value = MessageModal
        }else{

            let set_jisseki = null

            console.log("実績："+JSON.stringify(jisseki_all))

            for(let i = 0;i<jisseki_all.length;i++){
                for(let i2 = 0;i2 < jisseki_all[i].length;i2++){
                    let check_jisseki = jisseki_all[i][i2]
                    
                    if(check_jisseki.jokyo != 9){

                        // 実績に紐づくものが体験プログラムで、プログラムの種別が「2：制作・寄付」だったらそのままチェックイン済みとする
                        if(check_jisseki.shubetsu == 2 && kbn == 1){
                            set_jisseki = check_jisseki
                        }else if(kbn == 2 && (!kensyu_date || kensyu_date == '')){
                            // 実績に紐づくものが事前説明会で、説明会の開催日が未入力だったら、事前説明会のIDを持つ実績を格納する
                            if(check_jisseki.program_id == program_id){
                                set_jisseki = check_jisseki
                            }
                        }else{

                            let kaisai_set = Kaisai_setting(check_jisseki["kaisai_date"])
                            console.log("today_set:"+today_set +"/kaisai_set:"+ kaisai_set)
                            // 今日と同じ日付が存在する場合
                            if(today_set ==  kaisai_set){
                                set_jisseki = check_jisseki
                            }
                        }

                    }
                }
            }

            if(set_jisseki == null){
                
                message.value = "本日はこの"+program_name+"の参加日ではありません。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "checkin_non_kaisai";
                contentMessage.value = MessageModal

            }else{
                // チェックイン済みならその旨を表示
                if(set_jisseki.jokyo > "1"){

                    let set_message = "本日はチェックイン済みです。"
                    if(set_jisseki.shubetsu == 2){
                        set_message = "このプログラムは提出済みです。"
                    }
                    param = {check_jisseki:set_jisseki,message:set_message,checkin_date:set_jisseki["checkin_date"],cityname:cityname }
                    content.value = UserCheckin
                }else{
                    // 参加前ならチェックイン処理へ
                    set_checkin(set_jisseki,set_jisseki.program_id,kbn,set_date,program_id,user_id)
                }
            }
        }

    })
    .catch(error => {
        if(checkin_error == 6){
            loading_flg.value = false
            message.value = "チェックインを行うにはログインしてください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_login";
            contentMessage.value = MessageModal
        }else{
            checkin_error++
            setTimeout(checkin(program_id,user_id,kbn,kensyu_date),"1000")
            
        }
    })
}

//-------------------- チェックイン処理
let set_checkin_error = 0
const set_checkin = (set_jisseki,program_id,kbn,sanka_date,main_taiken_id,user_id) => {
    
    sanka_date.setHours(sanka_date.getHours()+9);
    let set_array = {user_id:user_id, program_kbn:kbn, program_id:program_id}
    // 実績に紐づくものが体験プログラムで、プログラムの種別が「1：施設・地域」だったら参加日を入力する
    if(set_jisseki.shubetsu == 1 && kbn == 1){
        set_array = {user_id:user_id, program_kbn:kbn, program_id:program_id, kaisai_date:sanka_date}
    }
    // 特殊説明会のフラグが立っていたらフラグも入れて送る
    if(set_jisseki.tokusyu){
        set_array.tokusyu = set_jisseki.tokusyu
    }
    
    axios.post(url+"Jisseki_CheckIn-Out",set_array, GlobalData.$ID_Token)
    .then(response => {
        // ソーシャルログイン時に利用する戻る社協英名、画面、IDを削除
        localStorage.removeItem('return_shakyo')
        localStorage.removeItem('checkin')
        localStorage.removeItem('checkin_id')

        
        // 履歴登録
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
        rireki_kanri_add(set_date,3,user_id,kbn,main_taiken_id,0)

        // 今日の日付（参加日と比較用）
        let disp_date = new Date(today);
        disp_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        disp_date = new Date(disp_date);

            
        param = {check_jisseki:set_jisseki,message:"チェックインしました。",checkin_date:disp_date,cityname:cityname }
        content.value = UserCheckin

    })
    .catch(error => {
//        alert("チェックイン時にエラーが発生しました。"+error)
        if(set_checkin_error == 6){
            loading_flg.value = false
            message.value = "チェックインを行うにはログインしてください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_login";
            contentMessage.value = MessageModal
        }else{
            set_checkin_error++
            setTimeout(function(){
                    
                param = { cmd:route.params.cmd, id:route.params.id }
                call(param)
            },"1000")
        }
    })

}

//---------------- 履歴を登録する
let rireki_add_error = 0
let rireki_kanri_add = function(toroku_date,kubun,taikenuser_id,program_kbn,program_id,mail_rireki_id){
    let set_choson_code = ""
    if(choson_code != ""){
        set_choson_code = choson_code
    }
    let send_data = {shakyo_name:route.params.shakyo,
        choson_code:set_choson_code,
        taikenuser_id:taikenuser_id,
        program_kbn:program_kbn,
        program_id:program_id,
        mail_rireki_id:mail_rireki_id,
        kubun:kubun,
        toroku_date:toroku_date,
        update_user:GlobalData.$User_email}

    // APIへ値を送信する
    axios.post(url+"Rireki_add",
    send_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
            
    })
    .catch(error => {
        if(rireki_add_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "rireki_update_error";
            contentMessage.value = MessageModal
        }else{
            rireki_add_error++
            setTimeout(function(){
                rireki_kanri_add(toroku_date,kubun,taikenuser_id,program_kbn,program_id,mail_rireki_id)
            },"1000")
        }
    })
}

async function Facility_update(mode,key,account_flg) {
  if(mode == 1){
    // 施設IDでの更新
    try{
      const res = await axios.post(url+"Facility_update", {
        facility_id: key,
        account_flg: account_flg
      });
    } catch (err) {
      console.log('施設IDでの施設情報の更新に失敗しました。:');
      console.log(err);
    }
  } else {
    // 施設コードでの更新
    try{
      const res = await axios.post(url+"Facility_update", {
        facility_code: key,
        account_flg: account_flg
      });
    } catch (err) {
      console.log('施設コードでの施設情報の更新に失敗しました。:');
      console.log(err);
    }
  }
}

// Cognitoユーザーを削除する
let cognito_delete_error = 0
let Cognito_Delete = function(){

    let set_email = GlobalData.$User_email
    let facility_id = GlobalData.facility_id
    let facility_code = GlobalData.facility_code
    let ID_Token =  GlobalData.$ID_Token
    
    // ログアウト
    var poolData = {
        UserPoolId : GlobalData.$UserPoolId,
        ClientId : GlobalData.$ClientId
    };
    var userPool = new CognitoUserPool(poolData);
    var cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        // ログアウト
        cognitoUser.signOut();
    }

    let send_array = {"facility_id": facility_id,"email":set_email}

  axios.post(GlobalData.$API_URL + "Cognito_FacilityDelete",
  send_array,
  ID_Token)
  .then(response => {
    
    if(response.data["status"] == 1){
        alert("Cognito_Deleteのstatusエラー")
    }else{
/*        
        // 情報を初期化
        GlobalData.$User_email = null
        GlobalData.facility_id = null
        GlobalData.kencd = null
        GlobalData.kengen = null
        GlobalData.facility_code = null
        GlobalData.$ID_Token = {headers: {"Authorization": ""}}    // 認証用IDトークン格納ヘッダー
        GlobalData.$identities = null // アイデンティティ（ソーシャルログインの場合はこれが入力される）
*/
        alert("アカウントの削除が完了しました。")
                                                                                                                        
        Facility_update(2,facility_code,false)  // 施設のアカウント未登録のフラグを設定する(key:施設コード)

        login_check()
    }
  })
  .catch(error => {
    
        if(cognito_delete_error == 6){
           alert("Cognito_Deleteを6回動作したがうまくいかなかった。")
        }else{
            cognito_delete_error++
            setTimeout(function(){Cognito_Delete()},"1000")
        }
        
        //Ninsho_error()
  })
}

// メッセージを表示するウィンドウでOKを押された時
let OK_message = function(){ 
    Close_message();//メッセージを表示するウィンドウを閉じる

    switch(message_method.value) {
        case "checkin_non_kaisai":
        case "checkin_non_moushikomi":
        case "checkin_non_kensyu":
            // １：申込んではいるが開催日ではない
            // ２：申込んでいない
            // ３；前提となる事前説明会への参加が行われていない
            // 同一URLの場合は直接親を呼ぶ
            call({ cmd:'Readcode'})
            break
        case "facility_delete":
            Cognito_Delete()
            break
        case "rireki_update_error":
            // 履歴のエラーなのでここでは何もしない
            break
        default:  // 上記以外のエラーは、致命的なのでlogoutしログイン画面に戻る
            logout()
            break
    }        

}

// メッセージを表示するウィンドウを閉じる
let Close_message = function(){
    message_flag.value = false;
    contentMessage.value = null
}

// スマホ用ホーム画面表示
const Smart_home = () => {
  router.push("/"+cityname+"/"+facility+"/Shisetsu").then(() => {
      router.go(0)   // ← ページ全体を再ロード（フルリロード）
  })
}

// スマホ用・検索ボタン（icon_search.png）をクリックした時の動作
const Smart_search = function() {

    // フォームオープンフラグ立て
    Smart_search_open.value = 1
    param = {all_bunrui_list:all_bunrui_list,search_param:search_param,cityname:cityname,
                gakusei_kbn_list:gakusei_kbn_list,
                gakusei_meisho_list:gakusei_meisho_list }
    content.value = UserSearchSmart

}

//---------------- 種別、分類１・２の設定ファイルを呼び出す
let category_read_error = 0
let Category_read = function(cmd){
    let set_url = url + "Taiken_bunrui_read"
    axios.post(set_url,{shakyo:route.params.shakyo}) 
    .then(response => {

        if( response.data.status == 1){
        }else{

            // 分類を格納する
            all_bunrui_list = response.data.csv_data

            if(cmd == "search"){
                taiken_dsp(cmd)
            }

        }


    })
    .catch(error => {
        
        if(category_read_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            category_read_error++
            setTimeout(function(){Category_read(cmd)},"1000")
        }
    })

}

// 申込者一覧を検索
let moushikomi_search_error = 0
let Moushikomi_search = function(jokyo) { 

    console.log(jokyo)

    let send_array = {"taiken_id":rireki_program_id}
    if(rireki_start_date != null){
        send_array.start_date = rireki_start_date
    }
    if(rireki_end_date != null){
        send_array.end_date = rireki_end_date
    }
    if(rireki_username != null){
        send_array.username = rireki_username
    }
    if(jokyo != null){
        send_array.jokyo = jokyo
    }

    axios.post(url + "Moushikomi_get",send_array,GlobalData.$ID_Token)  //ヘッダーを追加（IDトークンを送信）
    .then(response => {

        // ページトップへスクロール
        Page_scroll(0);

        // 子コンポーネントに送る値を格納
        // ShakyoTaikenRireki(検索結果)へ送る値
        param = {'results':response.data.all_moushikomi_info,
                    'taiken_program':response.data.taiken_program, 
                    'kubun':rireki_kubun,
                    'program_id':rireki_program_id,
                    'rireki_mode':rireki_mode}
        content.value = ShisetsuTaikenRireki

        param_left = {'kubun':rireki_kubun,"start_date":rireki_start_date,"end_date":rireki_end_date,"username":rireki_username}
        contentLeft.value = ShisetsuTaikenRirekiLeftbar
        left_bar_render++   // 左メニューの再描画
        // 子コンポーネントを再レンダリング
        Rendering_child()
    })
    .catch(error => {
    
        if(moushikomi_search_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_method.value = "change_error";
            message_cat.value = 0;
            message_flag.value = true;
            contentMessage.value = MessageModal
        }else{
            moushikomi_search_error++
            setTimeout(function(){Moushikomi_search(jokyo)},"1000")
        }
        
    })
}

// メッセージレコードを検索
let message_search_error = 0
let Message_search  = function() {  

    let choson_code = route.params.shakyo
    if(choson_code == "kawagoe"){
        choson_code = '11201'
    }
    if(choson_code == "tsurugashima"){
        choson_code = '11241'
    }


    let send_array = {"choson_code":choson_code,"order":rireki_order,"mode":rireki_mode}
    if(rireki_program_id != 0){
        send_array.program_id = rireki_program_id
    }
    if(rireki_start_date != null){
        send_array.start_date = rireki_start_date
    }
    if(rireki_end_date != null){
        send_array.end_date = rireki_end_date
    }
    if(rireki_username != null){
        send_array.username = rireki_username
    }

    axios.post(url + "Message_read",send_array,GlobalData.$ID_Token)  //ヘッダーを追加（IDトークンを送信）
    .then(response => {

        // ページトップへスクロール
        Page_scroll(0);

        // 子コンポーネントに送る値を格納
        // ShakyoTaikenRireki(検索結果)へ送る値
        param = {'results':response.data.message_kanri,'kubun':rireki_kubun,'program_id':rireki_program_id,'rireki_mode':rireki_mode}
        content.value = ShisetsuTaikenRireki

        param_left = {'kubun':rireki_kubun,"start_date":rireki_start_date,"end_date":rireki_end_date,"username":rireki_username}
        contentLeft.value = ShisetsuTaikenRirekiLeftbar
        left_bar_render++   // 左メニューの再描画
        // 子コンポーネントを再レンダリング
        Rendering_child()
    })
    .catch(error => {
    
        if(message_search_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_method.value = "change_error";
            message_cat.value = 0;
            message_flag.value = true;
            contentMessage.value = MessageModal
        }else{
            message_search_error++
            setTimeout(function(){Message_search ()},"1000")
        }
        
    })
}

// 子コンポーネントを再レンダリングする
let Rendering_child = function(){
    // v-if="displayStatus"で表示・非表示を繰り返し、再レンダリングする
    // ただtrueに戻すだけでは表示は切り替わらないので、nextTickで囲んでから戻すこと

    displayStatus.value = false
    nextTick(() => {
        displayStatus.value = true
    })
}

// ページの一番上にスクロールする：height＝位置（上から何pxか）
const Page_scroll = async (height) => {

    await nextTick()               // Vue の DOM 更新を待つ
    await new Promise(r => setTimeout(r, 0)) // ブラウザのレイアウト確定を待つ
        if(height == 0 ) return

        requestAnimationFrame(() => { // レイアウトが最終確定した次のタイミング
            // スマホ・PCのどちらか、横幅でチェック
            if (window.matchMedia("(max-width: 960px)").matches) {
                // スマホ
                setTimeout(window.scrollTo({top: height,left: 0,behavior: "auto",}), "500");
            } else {
                // PC
                const el = document.querySelector("#vy_main")
                if (el) {
                    setTimeout(el.scrollTo({ top: height, behavior: "auto" }), "500");
                }
            }
    })
}

//-------------- URLが変わった時に対応する処理を起動するためのフック -----------------
const wt = watch(route, () => {
    param = { cmd:route.params.cmd, id:route.params.id }
    call(param)
})

//-------------- URLに応じた処理のコンポーネントを呼び出す -------------------
const call = function(proc) {
    switch(proc.cmd) {
        case "search":   //------------ 検索
            // 一覧のページ数（PCのみ）を初期化
            store.state.current_page = 1

            loading_flg.value = true
            let shimekiri = 0
            if(proc.shimekiri0 ){
                shimekiri  = proc.shimekiri0
            }


            search_param = { bunrui1:proc.bunrui10, bunrui2:proc.bunrui20, keyword:proc.keyword0,
                             kaisai_date:proc.kaisai_date0, joken:proc.joken0 , shimekiri:shimekiri}

            store.state.taiken = search_param

            setTimeout(function(){Category_read(proc.cmd)}, "1000");
            
            Smart_search_open.value = 0
            
            break
        case "page_scroll"://----------ページトップまでスクロール
            Page_scroll(0)
            break
        case "init":   //-------------- 初期表示画面を表示(体験プログラム一覧)
            // content.value = null
            taiken_dsp_check()
            break
        case "Readcode":   //-------------- 二次元コードを読み込む画面を表示
            title = "二次元コード読取"
            content.value = ShisetsuMyCode
            render.value++
            contentLeft.value = Leftbar
            break
        case "loading_start":
            // ローディングアイコン表示
            loading_flg.value = true
            break
        case "loading_end":
            // ローディングアイコン解除（画面リロード）
            loading_flg.value = false
            location.reload()
            break
        case "loading_end_noreload":
            // ローディングアイコン解除
            loading_flg.value = false
            break
        case "checktaiken":  //-------------- チェックイン（体験）
            login_check()
         
            axios.post(url+"Taiken_read", {taiken_id:proc.t_id})
            .then(response => {
                let taiken_jizen_no = response.data.jizenkensyu_no

                if(taiken_jizen_no != [] && taiken_jizen_no != "" && taiken_jizen_no != null){
                    Jizen_jisseki_check(taiken_jizen_no,proc.t_id,proc.tu_id)
                }else{
                    checkin(proc.t_id,proc.tu_id,1)
                }
            })
            .catch(error => {
                console.log("体験チェックイン Taiken_readエラー:",error)
            })
            break
        case "checkjizen":  //-------------- チェックイン（事前説明会）

            login_check()
            // チェックイン前に事前説明会の種類を取得
            axios.post(url+"Jizen_read", {jizen_id:proc.t_id})
            .then(response => {

                let syurui = response.data.syurui
                    // 動画視聴期間は種類3（動画視聴）のみ利用する。未入力であれば日付を問わずチェックインOK
                    let kensyu_date = response.data.kensyu_date // 開催日または動画視聴期間（至）

                if(syurui == '4' || syurui == '5'){
                    // チェックイン処理へ
                    
                    // 今日の日付（参加日）
                    const today = new Date()
                    let set_date = new Date(today);
                    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
                    set_date = new Date(set_date);

                    let set_jisseki = {"program_kbn":2,"shubetsu":2,"kbn":1,"jizen_name":response.data.jizen_name,'tokusyu':'on'}
                    
                    setTimeout(function(){

                        // 自分の市区町村コードと説明会の市区町村コードが違う場合
                        if(choson_code != response.data.choson_code){
                            loading_flg.value = false
                            message.value = "所属社協が違うため、この特殊説明会は受けられません。";
                            message_cat.value = 0;
                            message_flag.value = true;
                            message_method.value = "checkin_non_kensyu";
                            contentMessage.value = MessageModal
                        }else{
                            set_checkin(set_jisseki,proc.t_id,2,set_date)
                        }
                    },"1000")
                    
                }else{
                    checkin(proc.t_id,tu_id,2,kensyu_date)
                }
            })
            .catch(error => {
                
                
                
             })
            break
        case "checkjigo":  //-------------- チェックイン（事後集会）
            login_check()
         
            checkin(proc.t_id,proc.tu_id,3)
            break
        case "checkio":  //-------------- 疑似的チェックイン／アウト
            //alert("enter checkio")
            checkio(proc.tu_id, proc.kbn, proc.t_id, proc.date, proc.start)
            break
        case "facility_delete":
                message.value = "当受入先を削除してもよろしいでしょうか？\n※削除してもデータは残りますが、ログインができなくなります。";
                message_cat.value = 1;
                message_flag.value = true;
                message_method.value = "facility_delete";
                contentMessage.value = MessageModal
            break
        case "scroll_position" :
            // 一覧のスクロール位置を保存する
            // スマホ・PCのどちらか、横幅でチェック（縦の位置の検知がそれぞれ違うため）
            if (window.matchMedia("(max-width: 960px)").matches) {
                // スマホ
                list_scrollpos = window.scrollY || document.documentElement.scrollTop;
            } else {
                // PC
                list_scrollpos = document.querySelector("#vy_main").scrollTop;
            }
            break;
        case "detail":
            // 体験プログラム検索から詳細画面への切替処理 （router.push）
            // 選択時はrouterで遷移
            loading_flg.value = true            
            // 詳細を編集モード（type.value = 1）にする
            //type.value = 1
            Read(proc.id,proc.cmd)

            break
        case "rireki_search":

            // 履歴画面を開く
            //1：申込者一覧、2：申込キャンセル、8：メッセージ
            if(proc.rireki_kubun != undefined){
                rireki_kubun = proc.rireki_kubun 
            }
            if(proc.start_date != undefined){
                rireki_start_date = proc.start_date // 履歴登録日（自）
            }else{
                rireki_start_date = ""
            }
            if(proc.end_date != undefined){
                rireki_end_date = proc.end_date // 履歴登録日（至）
            }else{
                rireki_end_date = ""
            }
            if(proc.username != undefined){
                rireki_username = proc.username // 履歴体験ユーザー名
            }else{
                rireki_username = ""
            }

            if(proc.order){
                rireki_order = proc.order // 並び替え項目
            }
            if(proc.mode){
                rireki_mode = proc.mode // 昇順・降順
            }
            if(route.params.id){
                rireki_program_id = route.params.id // 体験プログラムID
            }

            switch(rireki_kubun){  //1：申込者一覧、2：申込キャンセル、8：メッセージ
                case 1:
                    if(GlobalData.choson_code == null){
                        setTimeout(function(){Moushikomi_search(1)}, "1000");
                    }else{
                        Moushikomi_search(1)
                    }
                    break
                case 2:
                    if(GlobalData.choson_code == null){
                        // setTimeout(function(){Rireki_search()}, "1000");
                        setTimeout(function(){Moushikomi_search(9)}, "1000");
                    }else{
                        // Rireki_search()
                        Moushikomi_search(9)
                    }
                    break
                case 8:
                    if(GlobalData.choson_code == null){
                        setTimeout(function(){Message_search()}, "1000");
                    }else{
                        Message_search()
                    }
                    break
            }
            if(rireki_kubun == 2){
            }else{

            }
            break
        default:
            taiken_dsp_check()
            break
    }
}

// login_checkの後に実行したい
// setTimeout(function(){taiken_dsp_check()},"1000")
param = { cmd:route.params.cmd, id:route.params.id }
setTimeout(function(){call(param)},"1000")


</script>
